<template>
  <Page v-if="user">
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="subtitle">แก้ไขข้อมูลผู้ใช้</div>
            <div class="title">{{getUserName()}}</div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3" v-if="isServerError()">
              {{getErrorMessageFromErrorStatus(errorStatus)}}
            </small>
            <button
              type="button"
              :disabled="!isValid"
              @click.stop="submitUser"
              class="btn btn-primary">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="section-container">
        <UserEditForm
          :editProfile="true"
          :user.sync="user"
          :saveUserStateError.sync="saveUserState.error"
        />
      </div>
    </div>
  </Page>
</template>

<script>
/* eslint-disable no-underscore-dangle */

import _ from 'lodash';
import { mapGetters } from 'vuex';
import { updateUserByAccountId } from '@/user/api';
import Page from '@/layouts/Page.vue';
import UserEditForm from '@/user/UserEditForm.vue';

export default {
  data() {
    return {
      user: null,
      errorStatus: null,
      saveUserState: {
        error: {
          name: null,
        },
      },
      modal: false,
    };
  },
  components: {
    Page,
    UserEditForm,
  },
  watch: {
    currentUser() {
      this.mapCurrentUser();
    },
  },
  created() {
    this.mapCurrentUser();
  },
  computed: {
    ...mapGetters(['currentUser']),
    isValid() {
      return this.user.name
      && (_.every(this.saveUserState.error, _.isEmpty));
    },
  },
  methods: {
    mapCurrentUser() {
      this.user = _.cloneDeep(this.currentUser);
    },
    async submitUser() {
      try {
        // await this.validImage();
        const userId = _.get(this.user, 'id', this.user._id);
        const userResponse = await updateUserByAccountId(
          userId,
          this.user,
        );
        this.user = userResponse.data;
        this.$store.dispatch('setCurrentUser', this.user);
        this.errorStatus = null;
        this.$router.push('/');
      } catch (error) {
        this.errorStatus = error.response.status;
        this.saveUserState.error = error.response.data;
      }
    },
    getUserName() {
      return _.get(this.currentUser, 'name', this.user.id);
    },
    isServerError() {
      return this.errorStatus;
    },
    getErrorMessageFromErrorStatus(errorStatus) {
      if (errorStatus === 500 || errorStatus === 404) {
        return `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${errorStatus}`;
      }
      if (errorStatus === 422 || errorStatus === 409) {
        return 'กรอกข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';
</style>
